export default "__VITE_ASSET__7HmLWMZF__"